type PageMeta = { title: string; description: string }

const defaultMeta: PageMeta = {
  title: 'SyNeural — Building intelligence in the world',
  description:
    'SyNeural builds systems that help people develop sound judgment, researchers connect ideas, and organizations turn knowledge into action.',
}

const pageMeta: Record<string, PageMeta> = {
  '/research': {
    title: 'Research — SyNeural',
    description:
      'The research questions, priorities, and ideas behind SyNeural, including Cognocracy, a proposed civic governance concept.',
  },
  '/initiatives/cognocracy': {
    title: 'Cognocracy — A proposed civic framework | SyNeural',
    description:
      'Cognocracy is a concept proposal powered by SyNeural, exploring how structured assessment, capability development, and verified credentials could support institutional trust and readiness for public responsibility.',
  },
}

export function applyPageMeta(path: string) {
  const meta = pageMeta[path] ?? defaultMeta
  document.title = meta.title
  setMeta('name', 'description', meta.description)
  setMeta('property', 'og:title', meta.title)
  setMeta('property', 'og:description', meta.description)
}

function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attribute, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}
